import { GeoSource } from "../@types"

/**
 * @param reporterCountry The country where the client is running
 * @returns `true` if the object satisfies geo rules
 */
export default function (reporterCountry: string, rules?: GeoSource) {
  /* eslint-disable @typescript-eslint/dot-notation */
  // Disallow rule, if any, takes precedence over allow rule
  if (rules) {
    const country = rules["country"]
    if (country) {
      const disallow = country["disallow"]
      const allow = country["allow"]
      if (
        (disallow && -1 < disallow.indexOf(reporterCountry)) ||
        (allow && 0 > allow.indexOf(reporterCountry))
      ) {
        return false
      }
    }
  }
  return true
  /* eslint-enable @typescript-eslint/dot-notation */
}
